(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("HttpLib", [], factory);
	else if(typeof exports === 'object')
		exports["HttpLib"] = factory();
	else
		root["HttpLib"] = factory();
})(this, function() {
return 